import {
  DataGrid,
  GridColDef,
  GridEventListener,
  GridPaginationModel,
  GridRowsProp,
  GridSortModel,
} from "@mui/x-data-grid";
import { TableToolbar } from "./components/TableToolbar";
import { ErrorTwoTone } from "@mui/icons-material";
import { LinearProgress, Stack } from "@mui/material";
import { TableFilterProps } from "src/models/filter";

interface TableProps {
  rows: GridRowsProp;
  columns: GridColDef[];
  pageSizeOptions: number[];
  loading: boolean;
  refetch?: () => void;
  isFetching: boolean;
  paginationModel: GridPaginationModel;
  setPaginationModel: (paginationModel: GridPaginationModel) => void;
  sortModel?: GridSortModel;
  setSortModel?: (sortModel: GridSortModel) => void;
  totalRows: number;
  onRowClick?: (row: any) => void;
  error?: boolean;
  getRowId?: (row: any) => string;
  paginationMode?: "client" | "server";
  filterMode?: "default" | "custom" | "none";
  filterConfig?: TableFilterProps;
  onCellClick?: GridEventListener<"cellClick"> | undefined;
}

export function Table({
  rows,
  columns,
  pageSizeOptions,
  loading,
  refetch,
  isFetching,
  paginationModel,
  setPaginationModel,
  sortModel,
  setSortModel,
  totalRows,
  onRowClick,
  error,
  getRowId,
  filterConfig,
  paginationMode = "client",
  filterMode = "custom",
  onCellClick,
}: TableProps) {
  return (
    <DataGrid
      density="compact"
      slots={{
        loadingOverlay: LinearProgress,
        toolbar: TableToolbar,
        noRowsOverlay: () => (
          <Stack height="100px" alignItems="center" justifyContent="center">
            {error ? (
              <ErrorTwoTone fontSize="large" color="error" />
            ) : (
              "No rows"
            )}
          </Stack>
        ),
      }}
      slotProps={{
        toolbar: {
          refetch: refetch,
          isFetching: isFetching,
          filterConfig: filterConfig,
          paginationMode: paginationMode,
          filterMode,
        },
      }}
      rows={rows}
      autoHeight
      columns={columns}
      pagination={true}
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
      paginationMode={paginationMode}
      pageSizeOptions={pageSizeOptions}
      sortModel={sortModel}
      onSortModelChange={setSortModel}
      // checkboxSelection
      disableRowSelectionOnClick
      loading={loading || isFetching}
      rowCount={totalRows}
      onRowClick={onRowClick}
      getRowId={getRowId ? getRowId : (row) => row.id}
      onCellClick={onCellClick}
    />
  );
}

export default Table;
